var infoHelp = (function () {

    var setUpInfoHelp = function () {
      var data = {
        "a school": [{
            "action": "organise a fundraiser",
            "destination page": "Fundraising page",
            "destination link": "/fundraising/"
          },
          {
            "action": "educate about recycling",
            "destination page": "Recycle responsibly ",
            "destination link": "/recycle-responsibly/"
          },
          {
            "action": "organise a container collection",
            "destination page": "How it works for Groups",
            "destination link": "/how-it-works/how-it-works-for-groups/"
          }
        ],
        "a sports club": [{
            "action": "organise a fundraiser",
            "destination page": "Fundraising page",
            "destination link": "/fundraising/"
          },
          {
            "action": "educate about recycling",
            "destination page": "Recycle responsibly ",
            "destination link": "/recycle-responsibly/"
          },
          {
            "action": "organise a container collection",
            "destination page": "How it works for Groups",
            "destination link": "/how-it-works/how-it-works-for-groups/"
          }
        ],
        "a community group": [{
            "action": "organise a fundraiser",
            "destination page": "Fundraising page",
            "destination link": "/fundraising/"
          },
          {
            "action": "educate about recycling",
            "destination page": "Recycle responsibly ",
            "destination link": "/recycle-responsibly/"
          },
          {
            "action": "organise a container collection",
            "destination page": "How it works for Groups",
            "destination link": "/how-it-works/how-it-works-for-groups/"
          }
        ],
        "a business": [{
            "action": "better manage our recycling",
            "destination page": "Recycle responsibly ",
            "destination link": "https://returnandearn.org.au/recycle-responsibly/"
          },
          {
            "action": "organise a container collection",
            "destination page": "How it works for Groups",
            "destination link": "/how-it-works/how-it-works-for-groups/"
          },
          {
            "action": "organise a fundraiser",
            "destination page": "Fundraising page",
            "destination link": "/fundraising/"
          }
        ],
        "an individual": [{
            "action": "find a return point",
            "destination page": "Return Point page",
            "destination link": "/return-points/"
          },
          {
            "action": "check which containers are eligible",
            "destination page": "Eligible containers",
            "destination link": "how-it-works/containers/"
          },
          {
            "action": "how to best prepare to return",
            "destination page": "How it works",
            "destination link": "/how-it-works/"
          },
          {
            "action": "learn about refunds and donations",
            "destination page": "Refunds and Donations",
            "destination link": "/how-it-works/refunds-and-donations/"
          },
          {
            "action": "do more for my community",
            "destination page": "How it works for Groups",
            "destination link": "/how-it-works/how-it-works-for-groups/"
          },
          {
            "action": "read inspiring stories",
            "destination page": "News/Stories page",
            "destination link": "/news/"
          }
        ]
      };

      //add dropdown option
      if ($('.js-info-help__select-person').length) {
        for (var i = 0; i < Object.keys(data).length; i++) {
          let value = Object.keys(data)[i];
          let text = Object.keys(data)[i];
          $('.js-info-help__select-person').append($('<option>').attr('value', value).text(text).addClass('info-help__option'));
        }
        // initialise action memu
        populateActionItemAndLink(data, $('.js-info-help__select-person').val());
      }

      $('.js-info-help__select-person').change(function() {
        var person = $(this).val();
        populateActionItemAndLink(data, person);
      });

      $('.js-info-help__select-action').change(function() {
        var action = $(this).val();
        var person = $('.js-info-help__select-person :selected').text();
        populateActionLink(data, action, person);
      });

      function populateActionItemAndLink(data, key) {
        //remove last generated option
        $('.js-info-help__select-action').empty();
        //remove last generated link
        $('.js-info-help__link').attr('href', '');
        for (var i = 0; i < data[key].length; i++) {
          let value = data[key][i]["action"];
          let text = data[key][i]["action"];
          $('.js-info-help__select-action').append($('<option>').attr('value', value).text(text).addClass('info-help__option info-help__option--small'));
          // populate link
          if ($('.js-info-help__select-action :selected').text() == data[key][i]["action"]) {
            let link = data[key][i]["destination link"];
            $('.js-info-help__link').attr('href', link);
          }
        }
      }

      function populateActionLink(data, action, key) {
        //remove last generated link
        $('.js-info-help__link').attr('href', '');
        // populate link
        for (var i = 0; i < data[key].length; i++) {
          if (action == data[key][i]["action"]) {
            let link = data[key][i]["destination link"];
            $('.js-info-help__link').attr('href', link);
          }
        }
      }
    };

    var init = function () {
      setUpInfoHelp();
    };

    return {
      init: init
    };
  })();

export default infoHelp;



// WEBPACK FOOTER //
// ./FE-Build/src/js/modules/infoHelp.js